// Gedeelde datumveld-definities voor de tijds-widget-veldkiezer op lijst-modules.
// Gebruikt als config.index.timeFields (zie default/views/index.vue). De labels
// worden ook aangehouden voor de kolomtitels (#1380) zodat alles consistent blijft.
const baseTimeFields = [
    { value: 'createdAt', label: 'Aanmaakdatum', description: 'Datum waarop dit item werd aangemaakt' },
    { value: 'updatedAt', label: 'Aanpassingsdatum', description: 'Datum van de laatste wijziging' },
];

// Voor modules zonder updatedAt in het schema (bv. depots, teams).
const createdTimeField = [
    { value: 'createdAt', label: 'Aanmaakdatum', description: 'Datum waarop dit item werd aangemaakt' },
];

module.exports = { baseTimeFields, createdTimeField };
